module.exports = __webpack_public_path__ + "static/media/474.002fcbe0.webp";